module.exports = __webpack_public_path__ + "img/emoji.dfc3c0ca.svg";